import { useTranslation } from "react-i18next";
import CustomSharedConfirmationModal from "sipli-fleet-core/components/CustomSharedConfirmationModal/CustomSharedConfirmationModal";

interface UnitBrandDeleteProps {
  open: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const UnitBrandDelete = ({
  open,
  isLoading,
  onCancel,
  onConfirm,
}: UnitBrandDeleteProps) => {
  const { t } = useTranslation();

  return (
    <CustomSharedConfirmationModal
      open={open}
      title={t("delete_unit_make")}
      description={t("delete_unit_make_confirmation")}
      confirmText={t("delete")}
      cancelText={t("cancel")}
      isLoading={isLoading}
      onCancel={onCancel}
      onConfirm={onConfirm}
      centered
    />
  );
};

export default UnitBrandDelete;
